import { TradeSkillsBus } from './TradeSkillsBus';

export class PersonTradeSkillsBus {
  personTradeSkillId: any;
  tradeSkillId: any;
  personId: any;
  insertDt: Date;
  updateDt: Date;
  insertUserId: any;
  updateUserId: any;
  tradeSkill: TradeSkillsBus;
  selected: boolean = false;
}
